import type {
  GTMEventGlycerinDisplayVideo,
  GTMEventGlycerinVideoClick,
  GTMEventGlycerinVideoProgress,
} from '@packages/tracking/src/types/events';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';

export const useVideoTracking = () => {
  const dispatchTracking = useTracking();

  const trackGlycerinDisplayVideo = () => {
    dispatchTracking<GTMEventGlycerinDisplayVideo>({
      event: 'DisplayVideo',
      DisplayVideoData: {
        category: 'display-video',
        label: 'detailview',
      },
    });
  };

  const trackGlycerinVideoClick = ({
    source,
    videoId,
    action,
  }: Required<
    Pick<GTMEventGlycerinVideoClick['VideoClickData'], 'source' | 'videoId' | 'action'>
  >) => {
    dispatchTracking<GTMEventGlycerinVideoClick>({
      event: 'VideoClick',
      VideoClickData: {
        category: 'click-video',
        action,
        source,
        videoId,
      },
    });
  };

  const trackGlycerinVideoProgress = (
    props: Required<
      Pick<
        GTMEventGlycerinVideoProgress['VideoProgressData'],
        'progress' | 'totalDuration' | 'source' | 'videoId'
      >
    >,
  ) => {
    dispatchTracking<GTMEventGlycerinVideoProgress>({
      event: 'VideoProgress',
      VideoProgressData: { ...props },
    });
  };

  // GTM Tracking
  const trackVideoIconClick = () => {
    dispatchTracking({
      event: 'ga_event',
      eventAction: 'viewVideo',
      eventCategory: 'cliplister',
      eventLabel: 'detailview',
      eventValue: 'click',
    });
  };

  const trackVideoProgress = (progress: 'start' | '25' | '50' | '75' | '100') => {
    dispatchTracking({
      event: 'ga_event',
      eventAction: 'viewVideo',
      eventCategory: 'cliplister',
      eventLabel: 'detailview',
      eventValue: progress,
    });
  };

  return {
    trackGlycerinDisplayVideo,
    trackGlycerinVideoClick,
    trackGlycerinVideoProgress,
    trackVideoIconClick,
    trackVideoProgress,
  };
};
